import { compose, withState, withHandlers, lifecycle } from "recompose";
import getConfig from "./config";
import { mapConfigToValidation } from "../../FormValidation";
import { checkValidation } from "../../FormValidation/utils";

export const initValidation = {
  firstName: true,
  lastName: true,
  emailAddress: true,
  phoneNumber: true,
  websiteAddress: true,
  memberNumber: true,
};
const listIdsForValidation = Object.keys(initValidation);

export const tosAndAttachmentValid = (attachments, tos, dispatch) => {
  let attachmentValid = true;
  let tosValid = true;
  const attachmentList = attachments || [];
  const hasNotUploadedResume = !attachmentList.find(
    ({ type }) => type === "resume",
  );

  if (hasNotUploadedResume) {
    dispatch({
      type: "onFileChange",
      error: "Please upload a resume",
    });
    attachmentValid = false;
  }
  if (!tos) {
    dispatch({
      type: "onChangeCheckbox",
      error: "Please accept terms",
      value: "terms",
    });
    tosValid = false;
  }
  return attachmentValid && tosValid;
};

const withFormValidation = compose(
  withState("valid", "setValid", initValidation),
  withHandlers({
    setValid: (props) => (value) =>
      props.setValid({ ...props.valid, ...value }),
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      for (const id of listIdsForValidation) {
        checkValidation(
          prevProps.formState,
          this.props.formState,
          id,
          mapConfigToValidation(getConfig(this.props)),
          this.props.setValid,
        );
      }
    },
  }),
);

export default withFormValidation;
